import {CALL_API} from 'redux-api-middleware';
import {
  API_SUBGRANT_GET_REQUEST,
  API_SUBGRANT_GET_SUCCESS,
  API_SUBGRANT_GET_FAILURE,
} from 'common/types';

import {commonJwtHeader} from 'common/utils';
import {ENDPOINT_DYNAMIC_DATA} from 'common/endpoints';

export default {
  getSubGrant: (token, grantId, subgrantId) => {
    return {
      [CALL_API]: {
        endpoint: `${ENDPOINT_DYNAMIC_DATA}entities/first-entity?entityType=subGrant&grantId=${grantId}&subGrantId=${subgrantId}`,
        headers: commonJwtHeader(),
        method: 'GET',
        types: [
          API_SUBGRANT_GET_REQUEST,
          API_SUBGRANT_GET_SUCCESS,
          API_SUBGRANT_GET_FAILURE,
        ],
      },
    };
  },
};
